// import 'babel-polyfill'
import React from "react"
import ReactDom from "react-dom"
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Link,
  withRouter,
  Switch
} from "react-router-dom"
import { Provider, connect } from "react-redux"
import { push } from "react-router-redux"
import ConnectedRouter from "./ConnectedRouter"
import "./antd-overrides.css"
import "core-js/es7/array"
import "core-js/fn/string/includes"
import { Icon, Row, Col } from "antd"
import { LocaleProvider, Modal, Alert } from "antd"
import { StickyContainer, Sticky } from "react-sticky"

// SHARED
import configureStore, { history } from "./store/configureStore"
import registerServiceWorker, { unregister } from "./registerServiceWorker"

// CORE
import SplashMessagePage from "./core/SplashMessagePage"

// USER
import Start from "./user/Start"
import StepOne from "./user/StepOne"
import StepTwo from "./user/StepTwo"
import StepThree from "./user/StepThree"
import Signup from "./user/Signup"
import SignupPage from "./user/SignupPage"
import Login from "./user/Login"
import PasswordResetsPage from "./user/PasswordResetsPage"
import PasswordResetsEditPage from "./user/PasswordResetsEditPage"

// SUBSCRIPTIONS
import ManageEmailSubscriptionsPage from "./subscriptions/ManageEmailSubscriptionsPage"
import Subscriptions from "./subscriptions"

import Accountants from "./accountants/Accountants"
import Reports from "./reports/Reports"
import Enterprise from "./enterprise/Enterprise"
import TeamsFeatures from "./enterprise/TeamsFeatures"
import Home from "./home/HomePage"
import Trips from "./trips/Trips"
import Account from "./account/Account"
import AccountMenu from "./account/menu/Menu"
import TeamsMenu from "./enterprise/menu/TeamsMenu"
import Transactions from "./transactions/Transactions"
import ModalRoot from "./modal/ModalRoot"
import CouponUpsellModal from "./modal/CouponUpsellModal"
import enUS from "antd/lib/locale-provider/en_US"
import styled from "styled-components"
// Keep these CCS imports after components above

import "bootstrap/dist/css/bootstrap.css"
import "./styles/main.css"

import "./Root.css"

import TopNav from "./core/components/Navigation"
import SideNav from "./layout/SideNav"
import CtrlOptM from "./core/CtrlOptM"

const store = configureStore()

var isMobile = document
  ? Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 550
  : false

const MenuLayout = () => (
  <StickyContainer>
    <Row gutter={20} type="flex" justify="center">
      <Col
        className="leftNav"
        xs={0}
        sm={6}
        // md={4}
        // lg={3}
        // xl={2}
        // fixed amount max width
      >
        <Sticky>
          {({ style }) => {
            return (
              <div style={style}>
                <Switch>
                  <Route path="/teams" component={TeamsMenu} />
                  <Route path="/account" component={AccountMenu} />
                  <Route component={SideNav} />
                </Switch>
              </div>
            )
          }}
        </Sticky>
      </Col>
      <Col
        xs={24}
        sm={18}
        // md={20}
        className="content"
      >
        <Route exact path="/" component={Home} />
        <Route path="/transactions" component={Transactions} />
        <Route path="/data-exports" component={Reports} />
        <Route path="/trips" component={Trips} />
        <Route path="/enterprise" component={Enterprise} />
        <Route path="/teams" component={Enterprise} />
        <Route path="/accountants" component={Accountants} />
        <Route path="/dashboard" component={Home} />
        <Route path="/premium" component={Subscriptions} />
        <Route path="/account" component={Account} />
        <Route exact path="/teams-features" component={TeamsFeatures} />
      </Col>
    </Row>
  </StickyContainer>
)

ReactDom.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <LocaleProvider locale={enUS}>
        <div>
          <CtrlOptM />

          <header>
            <TopNav />
          </header>

          {isMobile && (
            <Alert
              message="Our web dashboard is best viewed from a desktop browser. Thank you!"
              banner
              closable
            />
          )}

          <ModalRoot />

          <main>
            <Switch>
              <Route path="/splash_message" component={SplashMessagePage} />
              <Route path="/step-one" component={StepOne} />
              <Route path="/step-two" component={StepTwo} />
              <Route path="/step-three" component={StepThree} />
              <Route
                exact
                path="/password_resets/new"
                component={PasswordResetsPage}
              />
              <Route
                exact
                path="/password_resets/:id/edit"
                component={PasswordResetsEditPage}
              />
              <Route
                exact
                path="/manage_email_subscriptions/:token_id"
                component={ManageEmailSubscriptionsPage}
              />
              <Route path="/start" component={Start} />
              <Route path="/login" component={Login} />
              <Route path="/signup" component={Signup} />
              <Route path="/signup/:signup_type" component={Signup} />
              <Route
                path="/trips/:token_id"
                component={() => (
                  <StickyContainer>
                    <Row type="flex" justify="center">
                      <Col xs={24} className="full-content">
                        <Trips />
                      </Col>
                    </Row>
                  </StickyContainer>
                )}
              />
              <Route
                path="/transactions/:token_id"
                component={() => (
                  <StickyContainer>
                    <Row type="flex" justify="center">
                      <Col xs={24} className="full-content">
                        <Transactions />
                      </Col>
                    </Row>
                  </StickyContainer>
                )}
              />

              <Route exact path="/account" component={AccountMenu} />
              <Route component={MenuLayout} />
            </Switch>
          </main>

          <footer>
            <ul>
              <li>
                <a href="http://blog.everlance.com" target="_blank">
                  Blog
                </a>
              </li>
              <li>
                <a href="http://help.everlance.com" target="_blank">
                  Help Center
                </a>
              </li>
            </ul>
          </footer>
        </div>
      </LocaleProvider>
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root")
)

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js